import { Button } from '@mui/material';
import styles from './RemindPeopleToCheckInButton.styles';

interface RemindPeopleToCheckInComponentProps {
  amountOfUsersToNotify: number;
  handleNotifyUsers: () => void;
}

const RemindPeopleToCheckInComponent = function ({ amountOfUsersToNotify, handleNotifyUsers }: RemindPeopleToCheckInComponentProps): JSX.Element {
  return (
    <Button 
      sx={styles} 
      variant="outlined" 
      type="button" 
      onClick={handleNotifyUsers}
    >
      Remind {amountOfUsersToNotify} People
    </Button>
  )
}

export default RemindPeopleToCheckInComponent;
